import { useEffect, useState } from "react";

export const useUserActivity = () => {
  const [isUserActive, setIsUserActive] = useState(false);

  useEffect(() => {
    const handleActivity = () => {
      setIsUserActive(true);
    };

    const resetActivity = () => {
      setIsUserActive(false);
    };

    // window.addEventListener("mousemove", handleActivity);
    window.addEventListener("mousedown", handleActivity);
    window.addEventListener("keydown", handleActivity);
    window.addEventListener("touchstart", handleActivity);

    window.addEventListener("mouseup", resetActivity);
    window.addEventListener("keyup", resetActivity);
    window.addEventListener("touchend", resetActivity);

    return () => {
      window.removeEventListener("mousemove", handleActivity);
      window.removeEventListener("mousedown", handleActivity);
      window.removeEventListener("keydown", handleActivity);
      window.removeEventListener("touchstart", handleActivity);

      window.removeEventListener("mouseup", resetActivity);
      window.removeEventListener("keyup", resetActivity);
      window.removeEventListener("touchend", resetActivity);
    };
  }, []);

  return isUserActive;
};
